import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { buildReadStoryPath } from "./storyRoUtils";

/** Legacy `/stories/:storyId` → canonical `/read-story/:storyId`. */
export default function StoriesToReadRedirect() {
    const { storyId } = useParams();
    const path = buildReadStoryPath(storyId);
    return <Navigate to={path || "/stories"} replace />;
}
